import { buildModelManager } from "../builder.js";
const DefaultCampaignDayStatsSelection = {
  __typename: true,
  id: true,
  campaignId: true,
  campaignsDelivered: true,
  campaignsRead: true,
  campaignsSent: true,
  createdAt: true,
  customerId: true,
  ordersGenerated: true,
  revenueGenerated: true,
  sendingDate: true,
  test: true,
  updatedAt: true
};
const modelApiIdentifier = "campaignDayStats";
const pluralModelApiIdentifier = "campaignDayStatss";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCampaignDayStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCampaignDayStatsSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignDayStatsSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignDayStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignDayStatsSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignDayStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignDayStatsSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findBySendingDate",
    findByField: "sendingDate",
    findByVariableName: "sendingDate",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignDayStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindBySendingDate",
    findByField: "sendingDate",
    findByVariableName: "sendingDate",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignDayStatsSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCampaignDayStats",
    operationReturnType: "CreateCampaignDayStats",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      campaignDayStats: { required: false, type: "CreateCampaignDayStatsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignDayStatsSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCampaignDayStats",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateCampaignDayStatsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCampaignDayStatsSelection
  },
  {
    type: "action",
    operationName: "updateCampaignDayStats",
    operationReturnType: "UpdateCampaignDayStats",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      campaignDayStats: { required: false, type: "UpdateCampaignDayStatsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignDayStatsSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCampaignDayStats",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateCampaignDayStatsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCampaignDayStatsSelection
  },
  {
    type: "action",
    operationName: "deleteCampaignDayStats",
    operationReturnType: "DeleteCampaignDayStats",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCampaignDayStats",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertCampaignDayStats",
    operationReturnType: "UpsertCampaignDayStats",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      campaignDayStats: { required: false, type: "UpsertCampaignDayStatsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCampaignDayStatsResult": { hasReturnType: false },
      "... on UpdateCampaignDayStatsResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignDayStatsSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCampaignDayStats",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertCampaignDayStatsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCampaignDayStatsSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "campaignDayStatsGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const CampaignDayStatsManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCampaignDayStatsSelection,
  operations
);
export {
  CampaignDayStatsManager,
  DefaultCampaignDayStatsSelection
};
//# sourceMappingURL=CampaignDayStats.js.map
